export class Breadcrumb {
  Prefix: string = '';
  Separator: string = '';
  NameOfFrontPage = '';
}
